import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ValuePropSection from "./components/ValuePropSection";
import SpreadsheetPreviewSection from "./components/SpreadsheetPreviewSection";
import TrustSection from "./components/TrustSection";
import ComparisonSection from "./components/ComparisonSection";
import InfoSections from "./components/InfoSections";
import ProductShowcaseSection from "./components/ProductShowcaseSection";
import CategoryButtonsSection from "./components/CategoryButtonsSection";
import FinalCtaSection from "./components/FinalCtaSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <ValuePropSection />
        <SpreadsheetPreviewSection />
        <TrustSection />
        <ComparisonSection />
        <InfoSections />
        <ProductShowcaseSection />
        <CategoryButtonsSection />
        <FinalCtaSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}